<template>
  <div>
    <page-header>
      <div class="boardTitle mt-3 mr-3 ml-3 font-weight-bold align-self-center">
        {{ boardTitle }}
      </div>

      <router-link class="mt-3 mb-1" :to="{ name: 'Board', params: { id: boardId } }">
        <div class="badgebutton active text-nowrap c-white">
          <i class="far fa-clock"></i>
          Back to Board
        </div>
      </router-link>
    </page-header>

    <div class="shifts-handover-overview">
      <ShiftsOverview />
    </div>

    <AppInfo />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import ShiftsOverview from '@/components/Overview/ShiftsOverview.vue';
  import { BoardModule, BoardStore } from '@/store/board';

  @Component({
    components: {
      PageHeader,
      ShiftsOverview,
    },
  })
  export default class ShiftsOverviewComponent extends Vue {
    private boardStore: BoardModule = BoardStore;

    get boardTitle() {
      return this.boardStore.board.title;
    }

    get boardId() {
      return this.$route.params.id;
    }

    async mounted() {
      await this.boardStore.getBoard(this.$route.params.id);
    }
  }
</script>

<style lang="scss" scoped>
  .shifts-handover-overview {
    margin: 1em;
    padding: 1.5rem;
    background-color: rgba(248, 248, 248, 0.9);
    background-blend-mode: difference;
    border-radius: 4px;
  }
</style>
